import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { RtUICoreOverlayModule } from '../core/overlay/overlay.module';
import { RtUIFormsModule } from '../forms/forms.module';
import { DateRangePickerLabelPipe, getDateRangePickerLabel } from './date-range-picker-label.pipe';
import { DateRangePickerComponent, getDateRangeValueDates } from './date-range-picker.component';

@NgModule({
  imports: [
    RtUICoreOverlayModule,
    RtUIFormsModule,
    I18nModule,
    CommonModule,
    DateRangePickerComponent,
    DateRangePickerLabelPipe,
  ],
  exports: [DateRangePickerComponent, DateRangePickerLabelPipe],
})
export class RtDateRangePickerModule {}

export {
  getDateRangeValueDates,
  getDateRangePickerLabel,
  DateRangePickerComponent,
  DateRangePickerLabelPipe,
};
